export enum JobStatusTypes {
	New = 1,
	Completed = 4,
	Canceled = 5
}
